import React from 'react';
import '../../../App.css';
import CardItem from '../../CardItem';
import Footer from '../../Footer';
import {
  domesticHotWaterPng,
  boilerJpg,
  waterTank2Jpg,
} from '../../../images/assets';

export default function mobileDomesticHotWater() {
  return(
    <>
        <div style={{backgroundColor:'rgb(248, 248, 248)'}}>

      <div style={{marginLeft:20 ,width:'90%', padding:20, textAlign:'center', display: 'inherit', alignItems: 'center', justifyContent: 'center',}}>
            <CardItem
              src={domesticHotWaterPng}
              text='Domestic Hot Water'
              path='/domesticHotWater'
            />
            </div>
            <div style={{width:'100%', padding:10, display: 'relative', flexDirection:'row'}}>
  
    <div >
            <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>What is central domestic hot water systems?</text>
          </div>
          <div style={{marginLeft:25, width:'80%', color:'rgb(50, 50, 50)'}}>
          <text style={{ fontSize:20}}>It’s a system consist of a central boiler which is not a huge one it’s just only 60 cm diameter and
           the height differs from capacity to another.
           This boiler delivers hot water to all the buildings so the hot water pipes for all bathrooms and kitchens are connected to a central pipe.
           One of the most common questions is if the boiler located far away from a bathroom will
           I wait a long time for the hot water to reach my bathrooms?! ... and the question is of course not because we design a return hot water line pipe by an engineering way which guarantees that you will have the hot water when you open tap almost immediately ( you may wait for 10 seconds).
           </text>
          </div>
          
          <div style={{marginTop:20, marginBottom:20}}>
          <text style={{ fontSize:20, marginLeft:25}}> The main components: </text>
          <div style={{marginLeft:25, width:'90%', color:'rgb(50, 50, 50)',fontSize:18 }}>
            <text>1- Boiler or storage hot water tank (The main source of heating)</text>
            </div>
            <div style={{marginLeft:25, width:'90%', color:'rgb(50, 50, 50)',fontSize:18 }}>
            <text>2- Circulation pump (The one which circulates the hot water on the pipes so when you open the tap you will get the hot water immediately)</text>
            </div>
            <div style={{marginLeft:25, width:'90%', color:'rgb(50, 50, 50)',fontSize:18 }}>
            <text>3- Control panel (Control when the circulating pump on and when it’s off so it reduces the running gas cost)</text>
              </div>
          </div>     
            </div>
            <div style={{marginLeft:60, width:'60%'}}>
            <CardItem
              src={boilerJpg}
              text='Boiler'
              path='/domesticHotWater'
            />
            </div>
            </div>
         
            <div style={{width:'90%', padding:10, display: 'relative', flexDirection:'row'}}>
    <div >
    <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>What are the benefits of central domestic hot water systems?</text>
          </div>
          <div style={{marginLeft:25, width:'80%', color:'rgb(50, 50, 50)',fontSize:20, marginBottom:10 }}>
            <text>- Reduce both capital and running costs.</text>
            </div>
            <div style={{marginLeft:25, width:'80%', color:'rgb(50, 50, 50)',fontSize:20, marginBottom:10 }}>
            <text>- Save spaces on bathrooms and kitchens. </text>
            </div>
            <div style={{marginLeft:25, width:'80%', color:'rgb(50, 50, 50)',fontSize:20, marginBottom:10 }}>
            <text>- Get hot water immediately when the tap is opening. </text>
            </div>
            <div style={{marginLeft:25, width:'80%', color:'rgb(50, 50, 50)',fontSize:20, marginBottom:10 }}>
            <text>- Safe solution.  </text>
            </div>
             
            </div>
            <div style={{marginLeft:50, width:'70%'}}>
            <CardItem
              src={waterTank2Jpg}
              text='Water Tank'
              path='/domesticHotWater'
            />
            </div>
            </div>

            <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
   
           
            </div>
             <section id="contact">
      <Footer />
      </section>
       </div>
    </>
  )
}
